// Header hide/show (EasePause pattern): scrolling down tucks the sticky header away, the first
// scroll up brings it back. Replaces Horizon's "scroll-up" mode, which fades the header in from
// opacity 0 and felt laggy. Horizon's sticky setting stays "always"; this only toggles a class.
// The shown state has transform: none, so the header never becomes the containing block of the
// fixed menu drawer (see HANDOFF 9s).
const section = document.querySelector('.header-section:has(#header-component)') || document.querySelector('#header-component')?.parentElement;
if (section) {
  let last = scrollY;
  let ticking = false;
  const busy = () => document.querySelector('.menu-drawer-container[open], header-menu[aria-expanded="true"]');
  const update = () => {
    ticking = false;
    const y = scrollY;
    const dy = y - last;
    if (y < 120 || busy()) section.classList.remove('cur-hide');
    else if (dy > 6) section.classList.add('cur-hide');
    else if (dy < -6) section.classList.remove('cur-hide');
    last = y;
  };
  addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
}
